import { CONTENT_TYPES } from 'dashboard/components-next/message/constants';
import { useCallsStore } from 'dashboard/stores/calls';
import whatsappCallingClient from 'dashboard/helper/whatsappCallingClient';
import types from 'dashboard/store/mutation-types';

export const TERMINAL_STATUSES = [
  'completed',
  'busy',
  'failed',
  'no-answer',
  'canceled',
  'missed',
  'ended',
];

export const isInbound = direction => direction === 'inbound';

const isVoiceCallMessage = message => {
  return CONTENT_TYPES.VOICE_CALL === message?.content_type;
};

const shouldSkipCall = (callDirection, senderId, currentUserId) => {
  return callDirection === 'outbound' && senderId !== currentUserId;
};

function extractCallData(message) {
  const contentData = message?.content_attributes?.data || {};
  const contentAttributes = message?.content_attributes || {};
  return {
    callSid:
      contentData.call_sid || contentData.call_id || contentAttributes.call_id,
    status: contentData.status,
    callDirection: contentData.call_direction || contentData.direction,
    conversationId: message?.conversation_id,
    inboxId: message?.inbox_id,
    provider:
      contentData.call_id || contentAttributes.call_id ? 'whatsapp' : 'voice',
    remoteSdp: contentData.remote_sdp || contentAttributes.remote_sdp,
    senderId: message?.sender?.id,
  };
}

export function handleVoiceCallCreated(message, currentUserId) {
  if (!isVoiceCallMessage(message)) return;

  const {
    callSid,
    callDirection,
    conversationId,
    inboxId,
    provider,
    remoteSdp,
    senderId,
  } = extractCallData(message);

  if (shouldSkipCall(callDirection, senderId, currentUserId)) return;

  const callsStore = useCallsStore();
  callsStore.addCall({
    callSid,
    conversationId,
    callDirection,
    inboxId,
    provider,
    remoteSdp,
    senderId,
  });
}

export function handleVoiceCallUpdated(commit, message, currentUserId) {
  if (!isVoiceCallMessage(message)) return;

  const {
    callSid,
    status,
    callDirection,
    conversationId,
    inboxId,
    provider,
    remoteSdp,
    senderId,
  } = extractCallData(message);

  const callsStore = useCallsStore();

  callsStore.handleCallStatusChanged({ callSid, status, conversationId });

  if (provider === 'whatsapp' && callDirection === 'outbound' && remoteSdp) {
    whatsappCallingClient.connectOutboundCall({ callId: callSid, remoteSdp });
  }

  const callInfo = { conversationId, callStatus: status };
  commit(types.UPDATE_CONVERSATION_CALL_STATUS, callInfo);
  commit(types.UPDATE_MESSAGE_CALL_STATUS, callInfo);

  const isNewCall =
    status === 'ringing' &&
    !shouldSkipCall(callDirection, senderId, currentUserId);

  if (isNewCall) {
    callsStore.addCall({
      callSid,
      conversationId,
      callDirection,
      inboxId,
      provider,
      remoteSdp,
      senderId,
    });
  }
}
